module.exports = __webpack_public_path__ + "static/media/nft-32.8069490c.jpg";